import {
    Button,
    Grid,
    Typography
}                                from "@mui/material";
import React, {
    useEffect,
    useRef
}                                from "react";
import {
    AddPermit,
    IGStyle,
    Permit
}                                from "../../constants";
import {useOnttrekkingenContext} from "../../context/OnttrekkingenContextProvider";

const PermitBlock = () =>
{
    const {
        companyDetails,
        setFormData,setEnergyDetails,setActivePage,setSubPage,
        setModalVisible,setSelectedPermitFilterRecord,
        setModalAction,setPermitDetails,
        refreshResource, setRefreshResource, setAlertVisible, setAlertText, selectedEnergyRecord
    } = useOnttrekkingenContext()


    //<editor-fold desc="Changeable Variables">

    const Title= "Vergunningen"
    const RMName= "ONT_PermitRM"

    const MasterRefresh = Permit

    const AddAction = AddPermit

    const AddButton = "Vergunning Toevoegen"
    const AddEnabled = true

    const DSLFilter = selectedEnergyRecord

    useEffect(() =>
    {
        RMRef.current?.addEventListener('recordSelected', (event: any) =>
        {
            setPermitDetails(event.detail.record)
            setActivePage(4)
            setSubPage(0)
            setSelectedPermitFilterRecord(`permitId =="` + event.detail.record?.id + "\"")

        });

    }, [])

    //</editor-fold>
    //<editor-fold desc="Master - Does not need changing">
    const RMRef = useRef<any>()

    useEffect(() =>
    {
        switch (refreshResource)
        {
            case MasterRefresh:
                console.log(" RFRESHING PERMIT")
                setTimeout(() => RMRef.current?.refresh(), 1000)
                break
        }
        setRefreshResource("")
    }, [refreshResource]);

    function AddObject()
    {
        setFormData(RMRef.current.data)
        setModalVisible(true)
        setModalAction(AddAction)

    }

    return (<>
        <Grid container justifyContent="center" direction={"column"}>
            <Grid container className={"rm-container"} direction={"row"}>
                <Grid container>
                    <Typography variant="h4" marginRight={"auto"}>
                        {Title}
                    </Typography>
                </Grid>

                <Grid item xs={8} container alignItems={"stretch"} className={"containerspacing"}>
                    {/*// @ts-ignore*/}
                    <ig-resource-master lang="nl-NL" ref={RMRef} class={"ig-columns"} style={IGStyle} resource-master-id={RMName} dsl-filter={DSLFilter}/>
                </Grid>

                <Grid container item className={"button-container"} xs={3} marginLeft={1} justifyContent={"flex-start"}>

                    <Grid item xs={4}>
                        <Grid container direction="column" item>
                            {AddEnabled && <Button variant={"contained"}  onClick={AddObject}>{AddButton}</Button>}
                        </Grid>
                    </Grid>

                </Grid>

            </Grid>
        </Grid>
    </>)
    //</editor-fold>
}

export default PermitBlock